<template>
  <section
    class="pricing section"
    :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]"
  >
    <div class="container">
      <div
        class="pricing-inner section-inner"
        :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]"
      >
        <c-section-header
          :data="sectionHeader"
          tag="h1"
          class="center-content reveal-from-bottom"
        />
        <!-- <div v-if="pricingSwitcher" class="pricing-switcher center-content reveal-from-top">
          <c-switch
            v-model="pricingSwitchOn"
            right-label="Billed in One Go"
          >Billed In {{pricing.numPhases}} Phases</c-switch>
        </div> -->
        <div
          class="tiles-wrap"
          :class="[
                        pushLeft && 'push-left',
                    ]"
        >
          <div
            class="tiles-item reveal-from-right"
            data-reveal-delay="400"
          >
            <div class="tiles-item-inner">
              <div class="pricing-item-content">
                <div class="pricing-item-header pb-24 mb-24">
                  <div class="pricing-item-title">Demo Tier</div>
                  <c-price-tag
                    :currencySymbol="currencySymbol"
                    :numPhases="1"
                    :lowPrice="400"
                    :highPrice="1280"
                    :pricingSwitchOn="pricingSwitchOn"
                  ></c-price-tag>
                  <div class="text-xs text-color-low">Proof-of-concept Demo</div>
                </div>
                <div class="pricing-item-features mb-32">
                  <div class="pricing-item-features-title h6 text-xs text-color-high mb-24">What’s included</div>
                  <ul class="pricing-item-features-list list-reset text-xs mb-32">
                    <li class="is-checked">Discovery + Roadmapping Session</li>
                    <li class="is-checked">A working proof of concept in 1~2 weeks</li>
                    <li class="is-checked">Deployment + Code Handoff</li>
                    <li>No Stripe payments flow / integration</li>
                    <li>No user registration/login (i.e. no Authentication & user roles)</li>
                    <li>Nothing too fancy- it's meant to demonstrate my competence & reliability</li>
                    <li>If you're convinced and opt for one of the other fixed price project tiers, the price of this PoC gets deducted.</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-8">
                <c-button
                  tag="router-link"
                  color="primary"
                  wide
                  to="/contact"
                >Discuss this option</c-button>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-right"
            data-reveal-delay="400"
          >
            <div class="tiles-item-inner">
              <div class="pricing-item-content">
                <div class="pricing-item-header pb-24 mb-24">
                  <div class="pricing-item-title">Micro Tier</div>
                  <c-price-tag
                    :currencySymbol="currencySymbol"
                    :numPhases="pricing.numPhases"
                    :lowPrice="pricing.tier2Price.low"
                    :highPrice="pricing.tier2Price.high"
                    :pricingSwitchOn="pricingSwitchOn"
                  ></c-price-tag>
                  <div class="text-xs text-color-low">B2B Standard SaaS MVP</div>
                </div>
                <div class="pricing-item-features mb-32">
                  <div class="pricing-item-features-title h6 text-xs text-color-high mb-24">What’s included</div>
                  <ul class="pricing-item-features-list list-reset text-xs mb-32">
                    <li class="is-checked">Discovery + Roadmapping Session</li>
                    <li class="is-checked">A complete working web app MVP in 45 days</li>
                    <li class="is-checked">Deployment + Code Handoff</li>
                    <li class="is-checked">Includes Stripe payments flow / integration</li>
                    <li>No user registration/login (i.e. no Authentication & user roles)</li>
                    <li>Basic documentation + Basic Client Training</li>
                    <li>After acceptance & handoff, no additional support</li>
                    <li>Meant for low-complexity MVPs</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-8">
                <c-button
                  tag="router-link"
                  color="primary"
                  wide
                  to="/contact"
                >Discuss this option</c-button>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-delay="200"
          >
            <div class="tiles-item-inner">
              <div class="pricing-item-content">
                <div class="pricing-item-header pb-24 mb-24">
                  <div class="pricing-item-title">Professional Tier</div>
                  <c-price-tag
                    :currencySymbol="currencySymbol"
                    :numPhases="pricing.numPhases"
                    :lowPrice="pricing.tier3Price.low"
                    :highPrice="pricing.tier3Price.high"
                    :pricingSwitchOn="pricingSwitchOn"
                  ></c-price-tag>
                  <div class="text-xs text-color-low">B2B Professional SaaS MVP + Support</div>
                </div>
                <div class="pricing-item-features mb-32">
                  <div class="pricing-item-features-title h6 text-xs text-color-high mb-24">What’s included</div>
                  <ul class="pricing-item-features-list list-reset text-xs mb-32">
                    <li class="is-checked">Discovery + Roadmapping Session</li>
                    <li class="is-checked">A complete working web app MVP in 45~60 days</li>
                    <li class="is-checked">Deployment + Code Handoff</li>
                    <li class="is-checked">Includes Stripe payments flow / integration</li>
                    <li class="is-checked">User registation/login + User Roles</li>
                    <li class="is-checked">Detailed documentation + Client Training</li>
                    <li class="is-checked">BONUS: 30 days of follow-up support via Email</li>
                    <li class="is-checked">OPTIONAL: ongoing support package</li>
                    <li class="is-checked">Meant for more complex B2B SaaS web application MVPs</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-8">
                <c-button
                  tag="router-link"
                  color="primary"
                  wide
                  to="/contact"
                >Discuss this option</c-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Pricing } from "@/utils/Pricing.js";
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
// import CSwitch from "@/components/elements/Switch.vue";
import CButton from "@/components/elements/Button.vue";
import CPriceTag from "@/components/elements/PriceTag.vue";

export default {
  name: "CPricing",
  components: {
    CSectionHeader,
    // CSwitch,
    CButton,
    CPriceTag,
  },
  mixins: [SectionTilesProps],
  props: {
    pricingSwitcher: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pricing: Pricing,
      currencySymbol: " ",
      sectionHeader: {
        title: "Get a working MVP with simple fixed project pricing",
        paragraph:
          "No hourly billing, no endless schedule extensions. Clear outcomes.",
      },
      pricingSwitchLabels: {
        type: "Billing Period", // screen-reader text
        default: "Billed In One Go",
        switchOn: "Billed In Phases",
      },
      pricingSwitchOn: false,
    };
  },
  created() {
    this.setCurrencySymbol();
  },
  methods: {
    async setCurrencySymbol() {
      const res = await fetch(
        "https://api.ipregistry.co/185.236.153.164?key=z73uhfttxygkdykz"
      );
      const json = await res.json();
      if (!json || !json.location || !json.location.continent) {
        this.currencySymbol = "$";
      } else if (json.location.continent.code === "EU") {
        this.currencySymbol = "€";
      } else {
        this.currencySymbol = "$";
      }
    },
  },
};
</script>